<template>
<li class="dropdown-item" @click="$emit('click', $event)">
  <slot />
</li>
</template>

<script>
export default {
}
</script>
